import {
  Fragment,
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
  React,
} from "react";
import { useSelector, useDispatch } from "react-redux";
import { Connection_List_Url } from "../../../Constants";
import ConnectionControl from "./ConnectionControl";
import DatasourceControl from "./DatasourceControl";
import FilterControl from "./FilterControl";
import { GetAllFilterList } from "../../../Helper/Services";
import { layoutActions } from "../../../store/layout-slice";
import { pageActions } from "../../../store/page-slice";
import { ReplaceSpecialCharToText } from "../../../Helper/WidgetDataCommon";
import SharedService from "../../../Helper/SharedService";
import GenericGoogleSheetService from "../../../Helper/GoogleSheetService";

const DataSectionSettings = forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const [dtSourceVal, setDtSourceVal] = useState("");
  const [dtSourceIsValid, setDtSourceIsValid] = useState(true);
  const [conSourceVal, setConSourceVal] = useState("");
  const [conSourceIsValid, setConSourceIsValid] = useState(true);
  const [conSourceItems, setConSourceItems] = useState([]);
  const [isShowFilter, setIsShowFilter] = useState(false);
  const [filterList, setFilterList] = useState([]);
  const [isGoogleSheet, setIsGoogleSheet] = useState(false);
  const sessionId = useSelector((state) => state.login.sessionId);
  const encodedEmail = useSelector(
    (state) => state.login.userDetail.encodedEmail
  );
  const exportToExcelDetails = useSelector(
    (state) => state.page.exportExcelDetails
  );
  const email = useSelector((state) => state.login.userDetail.email);
  const [filterVal, setFilterVal] = useState("null");
  const [filterDetails, setFilterDetails] = useState({
    issharedfilter: false,
    filterid: "",
    originaluserid: "",
    filterValue: "null",
  });
  const filterObjFromContext = useSelector(
    (state) => state.layout.addUpdateFilterObj
  );

  const gSheetObjFromContext = useSelector(
    (state) => state.layout.addUpdateGsheetObj
  );


  useEffect(() => {
    if (
      props.isEdit === true &&
      props.settings !== undefined &&
      props.settings["reports"] !== undefined &&
      props.settings["reports"] !== ""
    ) {
      setDtSourceVal(props.settings["reports"]);
      setConSourceVal(props.settings["connection"]);

      setIsGoogleSheet(SharedService.isGoogleSheet(props.settings["reports"]));

      let _filterVal = props.settings["Filter"];
      if (_filterVal === "") {
        _filterVal = "null";
      }

      setFilterVal(_filterVal);
      setFilterDetails({
        ...filterDetails,
        filterid: props.settings["FilterId"],
        filterValue: _filterVal,
        issharedfilter: props.settings["IsSharedFilter"],
        originaluserid: props.settings["OriginalUserId"],
      });

      getFilterList(
        props.settings["reports"],
        props.settings["connection"],
        sessionId,
        email
      );

      const exportToExcelData = {
        dataSource: props.settings["reports"],
        connectionName: props.settings["connection"],
        filterId: props.settings["FilterId"],
        filterName: props.settings["Filter"],
        isSharedFilter: props.settings["IsSharedFilter"],
        sharedFilterUserId: props.settings["OriginalUserId"],
      };
      dispatch(pageActions.setExportToExcelDetails(exportToExcelData));
      setIsShowFilter(true);

      if (SharedService.isGoogleSheet(props.settings["reports"])) {
        getGSheetConnections();
        setConSourceVal(props.settings["connection"]);
      }

    }

  }, [props.settings]);

  useEffect(() => {
    if (filterObjFromContext.filterName !== "") {
      getFilterList(dtSourceVal, conSourceVal, sessionId, email);
      setFilterVal(filterObjFromContext.filterName);
      setFilterDetails({
        ...filterDetails,
        filterid: filterObjFromContext.filterId,
        filterValue: filterObjFromContext.filterName,
        issharedfilter: filterObjFromContext.isSharedfilter,
        originaluserid: filterObjFromContext.userId,
      });
    }
  }, [filterObjFromContext]);

  useEffect(() => {
    if (gSheetObjFromContext.gsheetConnectionName !== "" || gSheetObjFromContext.isDeleted) {
      if (SharedService.isGoogleSheet(dtSourceVal)) {
        getGSheetConnections();
      }
      setConSourceVal(gSheetObjFromContext.gsheetConnectionName);
    }
  }, [gSheetObjFromContext]);

  useImperativeHandle(ref, () => ({
    validateDataSection() {
      const isValidForm = validateDataform();
      return {
        isDataSectionValid: isValidForm,
        data: {
          dataSourceName: dtSourceVal,
          connectionName: conSourceVal,
          filterName: filterVal,
          filterDetails: filterDetails,
        },
      };
    },
  }));

  const dataSourceChangeHandler = async (event) => {
    //const _val = event.target.value;
    const _val = event;
    setIsShowFilter(false);
    setFilterVal("null");
    setConSourceVal("");
    setDtSourceVal(_val);
    if (_val !== "") {
      setIsGoogleSheet(SharedService.isGoogleSheet(_val));
      setFilterList([]);
      setIsShowFilter(true);
      await getConnetionList(_val);
      dispatch(layoutActions.setSelectedDatasource(_val));
    }
    props.dtSourceChange(_val);
  };

  const getConnetionList = async (dtSourceName) => {

    if (SharedService.isGoogleSheet(dtSourceName)) {
      //console.log('google sheet');
      getGSheetConnections();
    }
    else {
      console.log('other data source', encodedEmail);
      const url = `${Connection_List_Url}/${dtSourceName}/${encodedEmail}/${sessionId}`;
      const getList = await fetch(url);
      if (getList.ok) {
        const getResponse = await getList.json();
        const res = JSON.parse(getResponse);
        const _items = res.map((item) => {
          return {
            value: item.connectionName,
            text: item.connectionName,
          };
        });
        setConSourceItems(_items);
        if (_items.length > 0) {
          setConSourceVal(_items[0].value);
          getFilterList(
            dtSourceName,
            _items[0].value,
            sessionId,
            email,
            setFilterList
          );

          //update export to excel details
          const exportToExcelData = {
            ...exportToExcelDetails,
            dataSource: dtSourceName,
            connectionName: _items[0].value,
            filterId: "",
            filterName: "null",
            sharedFilterUserId: "",
            isSharedFilter: "",
          };
          dispatch(pageActions.setExportToExcelDetails(exportToExcelData));
        }
      }
    }

  };


  function getGSheetConnections() {
    GenericGoogleSheetService.getGoogleConnectionList(sessionId).then((res) => {

      const _items = res.map((item) => {
        return {
          value: item,
          text: item,
        };
      });

      setConSourceItems(_items);
    }).catch(err => {
    });
  }

  const getFilterList = (dtSourceName, connectionName, sessionId, email) => {
    GetAllFilterList(dtSourceName, connectionName, sessionId, email)
      .then((json) => {
        setFilterList(json);

        if (props.settings !== undefined) {
          const _filterName = ReplaceSpecialCharToText(
            props.settings["Filter"]
          );

          //check the filtername not exists
          const filterExist = json.filter(
            (x) =>
              x.filterName === _filterName ||
              x.filterName ===
              ReplaceSpecialCharToText(filterObjFromContext.filterName)
          );
          if (filterExist.length === 0) {
            setFilterVal("null");
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setFilterList([]);
      });
  };

  const connectionChangeHandler = (event) => {
    const selectedValue = event; //event.target.value;
    setConSourceVal(selectedValue);
    dispatch(layoutActions.setSelectedConnection(selectedValue));

    if (selectedValue !== "" && selectedValue === "CreateNewConnection") {
      //open google oauth popup
      GenericGoogleSheetService.getGoogleAuthURL().then((res) => {

        const origin = window.location.origin;
        const authUrl = res.replace('https%3A%2F%2Fnsyteful.com', encodeURIComponent(origin));

        const popup = window.open(authUrl, '_blank', 'toolbar=yes, scrollbars=yes, resizable=yes, top=400, left=500, width=700, height=500');
        if (popup?.document) {
          const refreshInterval = setInterval(function () {
            console.log('Checking popup URL...');
            try {
              const code = getParameterValue('code');
              if (code != null) {
                console.log('access code', code);

                clearInterval(refreshInterval);
                popup.close();

                //open google sheet popup
                dispatch(layoutActions.setGsheetPopup());

                //post code to back-end api
                saveAccessCode(code);

              }

              // Check if popup was closed by user
              if (popup.closed) {
                clearInterval(refreshInterval);
                console.log('Popup closed by user');
              }
            } catch (error) {
              console.error('Error occurred while checking popup:', error);
              // Check if popup was closed by user
              if (popup.closed) {
                clearInterval(refreshInterval);
                console.log('Popup closed by user');
              }
            }

          }, 500);

          //Function to get parameter value from popup URL
          const getParameterValue = (param) => {
            if (!popup || !popup.location?.href) {
              console.error('Popup or its location is not accessible.');
              return null;
            }

            console.log('Popup:', popup);
            console.log('Popup URL:', popup.location.href);

            const queryString = popup.location.href.split('?')[1];
            if (!queryString) return null;

            const params = new URLSearchParams(queryString);
            return params.get(param);
          };


        }


      }).catch((err) => {
        console.log('getGoogleAuthURL err:' + err)
      })
    }

    if (selectedValue !== "" && selectedValue === "EditExistingConnection") {
      // Handle edit existing connection logic
      dispatch(layoutActions.setGsheetPopup({ edit: true }));
    }

    if (props.connectionChange) {
      //notify parent about connection change
      props.connectionChange(dtSourceVal, selectedValue);
    }

    //fetch filter list based on connection change
    getFilterList(dtSourceVal, selectedValue, sessionId, email);

  };

  const saveAccessCode = (code) => {
    if (code.length > 0) {
      GenericGoogleSheetService.storeGoogleAuthCode(code, sessionId).then((res) => {

      }).catch((err) => { })
    }
  }

  const validateDtSource = () => {
    if (dtSourceVal === "") {
      setDtSourceIsValid(false);
      setTimeout(() => {
        setDtSourceIsValid(true);
      }, 3000);
      return false;
    }
    return true;
  };

  const validateConnection = () => {
    if (conSourceVal === "") {
      setConSourceIsValid(false);
      setTimeout(() => {
        setConSourceIsValid(true);
      }, 3000);
      return false;
    }
    return true;
  };

  const validateDataform = () => {
    if (props.isCheckedValidation === undefined || props.isCheckedValidation) {
      const dtSourceValid = validateDtSource();
      if (!dtSourceValid) {
        return false;
      }

      const isConnectionValid = validateConnection();
      if (!isConnectionValid) {
        return false;
      }
    }

    return true;
  };

  const OnFilterChangeHandler = (filter) => {
    setFilterVal(filter.filterValue);
    setFilterDetails(filter);

    //update export to excel details
    if (
      filter.filterValue !== "CreateNewFilter" &&
      filter.filterValue !== "EditExistingFilter" &&
      filter.filterValue !== "CloneFilter"
    ) {
      const exportToExcelData = {
        ...exportToExcelDetails,
        filterId: filter.filterid,
        filterName: filter.filterValue,
        sharedFilterUserId: filter.issharedfilter,
        isSharedFilter: filter.originaluserid,
      };
      dispatch(pageActions.setExportToExcelDetails(exportToExcelData));
    }
  };


  return (
    <Fragment>
      <DatasourceControl
        value={dtSourceVal}
        onChangeHandler={dataSourceChangeHandler}
        isValid={dtSourceIsValid}
        dtList={props.dataSourceList}
        isEdit={props.isEdit}
      />
      {(!props.isEdit || isGoogleSheet) && (
        <ConnectionControl
          onChangeHandler={connectionChangeHandler}
          value={conSourceVal}
          isValid={conSourceIsValid}
          dtList={conSourceItems}
          isGSheet={isGoogleSheet}
        />
      )}

      {isShowFilter && (
        <FilterControl
          dtList={filterList}
          value={filterVal}
          onChange={OnFilterChangeHandler}
        />
      )}
    </Fragment>
  );
});

export default DataSectionSettings;
